export default __webpack_public_path__ + "static/media/Un_posto_in_giardino.2a215e4b.jpg";